import styled from 'styled-components'

import EditCityPlanPaymentsAndCostsFormUnstyled from './unstyled'

export const EditCityPlanPaymentsAndCostsForm = styled(
  EditCityPlanPaymentsAndCostsFormUnstyled,
)`
  .section-wrapper {
    padding: 40px;
    margin: 0 0 15px 0;

    .row {
      input {
        width: 154px;
      }
      label {
        white-space: normal;
      }
      input[type='checkbox'] {
        width: inherit;
      }

      .select-wrapper {
        width: 154px;
      }
    }

    .row:not(:last-child) {
      margin-top: 25px;
      margin-bottom: 30px;
    }
  }

  .submit-button {
    float: right;
    margin-bottom: 30px;

    input {
      width: auto;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/Campaigns/EditCityPlanPaymentsAndCosts/index.js